import styled, { css } from 'styled-components';

export const SectionContainer = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(3)};
    width: 100%;
  `}
`;
